import React from "react";

import PropTypes from "prop-types";

import axios from "axios";
import qs from "qs"; //post to php w/o file_get_contents('php://input');

import {
  Button,
  Checkbox,
  Form,
  Input,
  Message,
  Icon,
  Divider,
  Header,
  Segment,
  Label,
  Dropdown,
  TextArea,
  Flag,
  Modal
} from "semantic-ui-react";

import isEmail from "validator/lib/isEmail";

import SupportFields from "../components/SupportFields";

export default class ContactNew extends React.Component {
  static propTypes = {
    appState: PropTypes.object.isRequired,
    appStateUpdate: PropTypes.func.isRequired,
    callURL: PropTypes.string.isRequired,
  };

  //Test confirm: ?contact=23&confirm=HJD6F9&form=Web#vws

  constructor(props) {
    super(props);

    this.devMode = props.appState.devMode;

    this.serverCalled = false;
    this.axiosConfig = {
      withCredentials: true,
      credentials: "include",
      timeout: 10000,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-WP-Nonce": props.appState.session.nonce,
      },
    };

    this.state = {
      name: "",
      email: "",
      agree: false,
      validated: false,
      created: false,
      created_contact: 0,
      created_ticket: 0,
      confirmation: "",
      info: "",
      validationInfo: "",
      form: props.appState.form,
      department_id: 0,
      fields: [],
      language: props.appState.language,
      flag: props.appState.flag,
      message: "",
    };
  }

  txt = (text) => {
    //handle text translations from appState.config
    const { props } = this;
    if (!props.appState.config) return text;
    if (!props.appState.config.text) return text;

    if (text in props.appState.config.text)
      return props.appState.config.text[text];
    return text;
  };

  onChange = (event, data) => {
    const value = data.type === "checkbox" ? data.checked : data.value;
    const name = data.name;

    /*
    if (this.devMode)
      console.log(
        "VideoWhisper/screens/contactNew onChange",
        name,
        value,
        event
      );
*/
    this.setState(
      {
        [name]: value,
      },
      () => this.validation()
    ); //validate AFTER

  };

  validation() {
    const { props, state } = this;

    //validation
    let validationInfo = "";

    var valid = true;

    if (!this.state.agree) 
    {
      valid = false;
      validationInfo = this.txt("Check Agree to Terms and Conditions required.") + " ";
    }

    if (!isEmail(this.state.email)) 
    {
      valid = false;
      if (state.email) validationInfo = this.txt("Invalid email.") + " ";
      else validationInfo = this.txt("Email required.") + " ";
    }

    if (props.appState.config) if (props.appState.config.emailsUnsupported)
      if (props.appState.config.emailsUnsupported.includes(state.email.split('@').pop()))
      {
        valid = false;
        validationInfo = this.txt("Unsupported email provider") + ": " + state.email.split('@').pop() + " ";
      }

    if (this.state.name.length < 3) 
    {
      valid = false;
      validationInfo = this.txt("At least 3 characters name required.") + " ";
    }

    /*
    if (this.devMode)
      console.log(
        "VideoWhisper/screens/contactNew validation",
        valid,
        this.state.agree,
        this.state.validated
      );
	  */
    if (valid !== state.validated || validationInfo != state.validationInfo) this.setState({ validated: valid, validationInfo: validationInfo });
  }

  onSubmit = (e) => {
    e.preventDefault();

    if (this.devMode)
      console.log("VideoWhisper/screens/contactNew onSubmit", this.state);

    this.serverCall();
  };

  onSubmitConfirm = (e) => {
    e.preventDefault();

    if (this.devMode)
    console.log("VideoWhisper/screens/contactNew onSubmitConfirm", this.state);
 
    this.props.appStateUpdate({ 
      contact_id: this.state.created_contact, 
      ticket_id: this.state.created_ticket, 
      confirm: this.state.confirmation, 
      screen: 'contactConfirm' });
  };

  serverCall = () => {
    const { props, state } = this;
    const self = this;

    if (this.devMode)
      console.log(
        "VideoWhisper/screens/contactNew serverCall",
        props.callURL,
        state
      );

    axios
      .post(props.callURL, qs.stringify(state), this.axiosConfig)
      .then(function (response) {
        self.serverProcess(response);
      })
      .catch(this.serverError.bind(this));

    this.serverCalled = true;
  };

     	// Helper function to safely call gtag with retry limit
       safeTrackEvent(eventName, params, attempt = 0, eventState = '') {
        
        if (eventState) if (this.state.eventState) return; //already tracked

        const maxAttempts = 2; // Maximum number of attempts to check for gtag
      if (this.devMode) console.log('VideoWhisper/screens/contactNew safeTrackEvent:', eventName, params, attempt);
    
        if (typeof window.gtag === 'function') {
          // gtag is defined, so you can safely track the event
          window.gtag('event', eventName, params);
        if (this.devMode) console.log('VideoWhisper/screens/contactNew safeTrackEvent: SENT', eventName, params, attempt);
        if (eventState) this.setState({eventState: true});

        } else if (attempt < maxAttempts) {
          // gtag isn't defined yet, and we haven't reached the max attempts
          setTimeout(() => this.safeTrackEvent(eventName, params, attempt + 1), 500);
        } else {
          // Maximum attempts reached, could log this or handle as needed
          if (this.devMode) console.error('VideoWhisper/screens/contactNew safeTrackEvent: gtag not available after multiple attempts', maxAttempts);
        }
      }

  serverProcess(response) {

    const { props } = this;

    if (this.devMode)
      console.log(
        "VideoWhisper/screens/contactNew serverProcess:",
        response,
        this.state
      );

    const data = response.data;

    if (data.created) if (props.appState.config.gtag.contactNew)
    this.safeTrackEvent('conversion', {
      'send_to': props.appState.config.gtag.contactNew,
      'event_category': 'VideoWhisper Support',
      'event_label': 'New Contact',
      'value': 1
      }, 0);  

    if (data.session) this.props.appStateUpdate({ session: data.session }, {});

    if (data.info) this.setState({ created: data.created, created_contact: data.contact, info: data.info, created_ticket: data.ticket });
  }

  serverError(error) {
    console.log("VideoWhisper/screens/contactNew serverError:", error);
    this.setState({ created: false });
  }


  languageModalClose = () => this.setState({ languageModalShow: false })
   onLanguageButton = () => this.setState({ languageModalShow: true});

  language2flag(lang){
    const flags = { 'en-us':'us', 'en-gb':'gb', 'pt-br':'br', 'pt-pt':'pt', 'zh':'cn', 'ja':'jp', 'el':'gr', 'da':'dk', 'ko':'kr', 'nb':'no' };
    if (flags[lang]) return flags[lang];
    return lang;
  }

  onLanguageChange(event, data) {

    if (this.devMode)  console.log('VideoWhisper/screents/contactNew onLanguageChange', data, event);

    this.setState({
      language: data.value,
      flag: this.language2flag(data.value),
      languageModalShow: false,
  });

    this.props.appStateUpdate( { language : data.value, flag: this.language2flag(data.value) } );
 }

 componentDidMount()
 {
  if (this.devMode)
    console.log("VideoWhisper/screens/contactNew componentDidMount", this.props);

  const { props } = this;

  if (!this.state.department_id && this.props.appState.config.departmentDefault)
    this.setState({
      department_id: this.props.appState.config.departmentDefault,
    });

  if (props.appState.form) if (props.appState.config.form.gtagView) this.safeTrackEvent('conversion', {
    'send_to': props.appState.config.form.gtagView,
    'event_category': 'VideoWhisper Support',
    'event_label': 'Form View ' + props.appState.form,
    'value': 0.1
    }, 0, 'formView' + props.appState.form);  

  if (props.appState.config.gtag.contactView) this.safeTrackEvent('conversion', {
    'send_to': props.appState.config.gtag.contactView,
    'event_category': 'VideoWhisper Support',
    'event_label': 'Contact View',
    'value': 0.1
    }, 0, 'contactView');
 }

  render() {
    const { state, props, onChange, txt } = this;


    var formCode = "";
    if (props.appState.form && props.appState.config.form) {
      formCode = (
        <div key="contactForm">
          <Divider horizontal>
            <Header size="small">
              <Icon name="write" size="small" />
              {props.appState.form}
            </Header>
          </Divider>
          <Form.Field>
            <small>{props.appState.config.form.instructions}</small>
          </Form.Field>
          <SupportFields
            appState={props.appState}
            upState={state}
            upStateUpdate={(params) => this.setState(params)}
            key="formFields"
            fields={props.appState.config.form.fields}
          />
            {props.appState.config.form.terms?( <Form.Field><small>{props.appState.config.form.terms}</small></Form.Field> ):""}   
        </div>
      );
    }

    var departmentSelectCode = "";
    var departmentCode = [];
    var topicCode = "";

    if (!props.appState.form && props.appState.config.registerConversation)
    {
      
      var contextCode = "";

      if (
        props.appState.config.context.content ||
        props.appState.config.context.creator
      )
        contextCode = (
          <Form.Field inline>
            {" "}
            {props.appState.config.context.content ? (
              <>
                {" "}
                <Label basic>
                  <Icon name="file" /> {props.appState.config.context.content}
                </Label>
              </>
            ) : (
              ""
            )}
            {props.appState.config.context.url ? (
              <>
                <Button
                  basic
                  compact
                  size="tiny"
                  icon
                  href={props.appState.config.context.url}
                  target="Content">
                  <Icon name="linkify" />{" "}
                </Button>
              </>
            ) : (
              ""
            )}{" "}
            {props.appState.config.context.creator ? (
              <>
                {" "}
                <Label basic>
                  <Icon name="user" /> {props.appState.config.context.creator}
                </Label>
              </>
            ) : (
              ""
            )}
          </Form.Field>
        );

      if (props.appState.config.departments)
      {

      departmentSelectCode =(
        <Form.Group key="Department">
        <Form.Field>
        <label>
                <Icon name="box" /> {txt("Department")}
              </label>
          <Dropdown
            name="department_id"
            placeholder="Select Department..."
            selection
            options={props.appState.config.departments}
            value={state.department_id}
            onChange={onChange}
          />
        </Form.Field>
        {contextCode}
      </Form.Group>);

      //department fields
      var selectedDepartment = null; //selected department
      if (state.department_id && state.department_id > 0)
        if (props.appState.config.departments) {
          selectedDepartment = props.appState.config.departments.find(
            (item) => item.value == state.department_id
          );

          if (selectedDepartment)
          {
            if (selectedDepartment.instructions) departmentCode.push(<Message size="small" key="instructions">{selectedDepartment.instructions}</Message>);

            if (selectedDepartment.fields) {
              departmentCode.push(
                <SupportFields
                  appState={props.appState}
                  upState={state}
                  upStateUpdate={(params) => this.setState(params)}
                  key="DepartmentFields"
                  fields={selectedDepartment.fields}
                />
              );
            }
          }
        }

        if (selectedDepartment)
        {
//language
var languageModalCode = '';
var codeLanguage = '';

if (props.appState.config.multilanguage && props.appState.config.languages) {

  codeLanguage = ( <Form.Field key="languageButton"> <Button compact icon type="button" data-tooltip={txt('My Language')} onClick={this.onLanguageButton} inverted={props.appState.config.darkMode}><Flag name={props.appState.flag} /></Button>   </Form.Field>);

  const field = props.appState.config.languages;

   languageModalCode = (
    <Modal key='languageModal' closeIcon
    open={state.languageModalShow}
    onClose={this.languageModalClose}
    size='small' basic={props.appState.config.darkMode}
  >
    <Header icon='flag' content={txt("My Language")} />
    <Modal.Content>
    <Form>
    <Dropdown name={field.name} selection compact fluid
           className={props.appState.config.className + " v-select"} data-position="right center" 
           value={props.appState.language} options={field.options} flag={props.appState.flag}
           onChange={(e, data)=>this.onLanguageChange(e, data)} />
      <div>{field.details}</div>
    </Form>
    </Modal.Content>
  </Modal>
    );        
}

        topicCode = (
          <>
          <Form.Field key="message">
               <label>
                  <Icon name="comment" /> {txt("Topic")}
                </label>
          <TextArea
            name="message"
            placeholder={txt("Describe the topic, in brief. You can add more details after opening conversation.")}
            onChange={onChange}
            value={state.message}></TextArea> 
        </Form.Field>
        {codeLanguage}     
        {languageModalCode}
        </>
        );

        }

        //departments
      }

  }
    
  

    if (!state.created)
      return (
        <div className="layoutFull" key="layoutContact">
          <Form onSubmit={this.onSubmit}>
            {props.appState.form ? (
              <Header key="contactHeader">
                {" "}
                <Icon name="write" size="small" />{" "}
                {txt("Provide your contact details, to send form.")}{" "}
              </Header>
            ) : (
              <Header key="formHeader">
                <Icon name="comments" size="small" />
                {txt(
                  "Provide your contact details, to open conversation."
                )}{" "}
              </Header>
            )}
            <Divider />
            <Form.Field>
              <label>
                <Icon name="user" /> {txt("Name")}
              </label>
              <Input
                name="name"
                placeholder={txt("Name")}
                value={state.name}
                onChange={onChange}
              />
            </Form.Field>
            <Form.Field>
              <label>
                <Icon name="mail" /> {txt("Email")}
              </label>
              <Input
                name="email"
                placeholder={txt("Email")}
                value={state.email}
                onChange={onChange}
              />
            </Form.Field>

            {formCode}
            {departmentSelectCode}
            {departmentCode}
            {topicCode}

            <Form.Field>
              <Checkbox
                name="agree"
                label={txt("I agree to the Terms and Conditions")}
                checked={state.agree ? true : false}
                onChange={onChange}
              /> &nbsp;
              <Button icon size="tiny" compact href={props.appState.config.termsURL} target="_terms">
            <Icon name="external" />
             </Button>    
            </Form.Field>
            <Button disabled={!state.validated || state.created} type="submit">
              {txt("Submit")}
            </Button>
            {state.info ? <Message>{state.info}</Message> : ""}
            {state.validationInfo ? (
              <Message >{state.validationInfo}</Message>
            ) : (
              ""
            )}
          </Form>
        </div>
      );
    else           //include form to submit confirmation code for contact
      return (
        <div className="layoutFull" key="layoutContact">
          <Segment>
            {" "}
            <Icon name="check circle" />{" "}
            {state.info ? <Message>{state.info}</Message> : ""}
          </Segment>
          <Form onSubmit={this.onSubmitConfirm}>
          <Form.Field>
              <label>
                <Icon name="key" /> {txt("Confirmation Code From Email")}
              </label>
              <Input
                name="confirmation"
                placeholder={txt("Confirmation Code From Email")}
                value={state.confirmation}
                onChange={onChange}
              />
            </Form.Field>
            <Button type="submit" disabled={state.confirmation.length <3}>
              {txt("Confirm")}
            </Button>
          </Form>             
        </div>
      );
  }
}
